export default __webpack_public_path__ + "static/media/logo-redebank.01b6aa05.png";